import {
  getDestination,
  getOrigin,
} from '@web-platform/shared-universal-redux/src/selectors/search';

import type { State } from '@web-platform/shared-universal-types/src/redux/banana/state/state-banana-types';

export const isSameOriginAndDestinationSearch = (state: State): boolean => {
  const origin = getOrigin(state);
  const destination = getDestination(state);

  if (origin && destination && origin.id === destination.id) {
    return true;
  }

  return false;
};
